/** @format */

// SEO: When adding or removing public routes, update the Django sitemap
// at server/backend/sitemaps.py to keep sitemap.xml in sync.

import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Link, Outlet } from "@tanstack/react-router";

import Header from "@/utils/Header";
import InlineErrorBoundary from "@/utils/InlineErrorBoundary";
import { RouteErrorComponent } from "@/utils/RouteErrorComponent";

export interface RouterContext {
  queryClient: QueryClient;
}

function NotFound() {
  return (
    <main className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
      <h1 className="text-6xl font-bold text-slate-400">404</h1>
      <p className="mt-4 text-xl text-slate-300">Page not found</p>
      <p className="mt-2 text-slate-400">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link to="/" className="mt-6 text-blue-400 hover:text-blue-300 transition-colors">
        Back to Home
      </Link>
    </main>
  );
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <>
      <InlineErrorBoundary name="Header">
        <Header />
      </InlineErrorBoundary>
      <main>
        <Outlet />
      </main>
    </>
  ),
  errorComponent: RouteErrorComponent,
  notFoundComponent: NotFound,
});
